export default __webpack_public_path__ + "static/media/leftArrow.899cc395.svg";